import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TAny } from "@app/lib/models/common.type";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { AbstractHttpBaseService } from "@app/lib/services/http-base.service";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class BaseHttpService extends AbstractHttpBaseService {

    private _error: Subject<TAny> = new Subject();

    public error$ = this._error.asObservable();

    constructor(
        http: HttpClient,
        appConfig: AppConfiguration
    ) {
        super(http, appConfig)
    }

    protected override handleError(data: IResponse<TAny>): void {
        this._error.next(data);
    }

}